var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuit = function SvgSuit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    viewBox: "0 0 96 96",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02128 0 0 1.01053 -1288.851 -561.853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1262 556h94v95h-94z",
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1262 556h94v95h-94z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1261 381h97v114h-97z",
    style: {
      fill: "none"
    },
    transform: "matrix(.96907 0 0 .83333 40 238.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98947 0 0 .98958 1031.453 556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328 30.968a9.87 9.87 0 0 0-3.958-7.915L309.198 12h-57.396l-14.844 11.053A9.87 9.87 0 0 0 233 30.968v55.2c0 5.43 4.356 9.832 9.73 9.832h75.54c5.374 0 9.73-4.402 9.73-9.832z",
    style: {
      fill: "#ebebeb"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328 30.968a9.87 9.87 0 0 0-3.958-7.915L309.198 12h-57.396l-14.844 11.053A9.87 9.87 0 0 0 233 30.968v55.2c0 5.43 4.356 9.832 9.73 9.832h75.54c5.374 0 9.73-4.402 9.73-9.832z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98958 0 0 1 118.208 0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 76a5 5 0 0 1-5-5c0-1.326.527-2.598 1.464-3.536A5 5 0 0 1 157 66h7V5h48v91h-61a5 5 0 0 1 0-10h18.002A5 5 0 0 0 174 81.002v-.004A5 5 0 0 0 169.002 76H157"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 76a5 5 0 0 1-5-5c0-1.326.527-2.598 1.464-3.536A5 5 0 0 1 157 66h7V5h48v91h-61a5 5 0 0 1 0-10h18.002A5 5 0 0 0 174 81.002v-.004A5 5 0 0 0 169.002 76H157",
    style: {
      fill: "#b8b8b8"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 76a5 5 0 0 1-5-5c0-1.326.527-2.598 1.464-3.536A5 5 0 0 1 157 66h7V5h48v91h-61a5 5 0 0 1 0-10h18.002A5 5 0 0 0 174 81.002v-.004A5 5 0 0 0 169.002 76H157"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 20h8v39h-8z",
    style: {
      fill: "#858fa0"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M126 90a4 4 0 0 1-2.828-1.172A4 4 0 0 1 122 86V74a4 4 0 0 1 4-4c1.061 0 2.078.421 2.828 1.172A4 4 0 0 1 130 74v4.002A4 4 0 0 0 133.998 82H134c1.061 0 2.078.421 2.828 1.172a3.995 3.995 0 0 1 0 5.656A4 4 0 0 1 134 90z",
    style: {
      fill: "#b8bdc6"
    },
    transform: "matrix(-.98958 0 0 1 442.792 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 58v28h-8v-1.002a7 7 0 0 0-6.999-6.997L205 78h-2c-5.523 0-10-4.477-10-10v-6c0-.796.316-1.559.879-2.121A3 3 0 0 1 196 59h16v-1z",
    style: {
      fill: "#969ea6"
    },
    transform: "matrix(.98958 0 0 1 118.208 0)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 80,
    r: 3,
    style: {
      fill: "#a1aeb5"
    },
    transform: "matrix(1.63194 0 0 1.6493 1042.667 499.264)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 80,
    r: 3,
    style: {
      fill: "#fff"
    },
    transform: "matrix(1.63194 0 0 1.6493 1040.708 497.285)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 80,
    r: 3,
    style: {
      fill: "#e3e3e3"
    },
    transform: "matrix(.65278 0 0 .65972 1208.146 576.451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.515 15.154c3.624.303 5.429 5.535-.273 5.7-2.165.062-2.953.238-4.139.586-4.246 1.247-7.266 4.532-7.352 8.049-.061 7.618-.44 15.244.002 22.855.089 1.186 2.52 1.802 2.497 1.802 5.743.16 4.597 7.492-2.736 5.419-3.997-1.13-7.18-3.924-7.263-7.223q-.092-11.463 0-22.924c.184-7.51 8.762-14.223 18.977-14.272q.144.002.287.008",
    style: {
      fill: "#969ea6",
      fillRule: "nonzero"
    },
    transform: "matrix(.78333 0 0 1.04033 1088.1 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#969ea6"
    },
    transform: "matrix(1.25893 0 0 1.58333 972.727 519.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#969ea6"
    },
    transform: "matrix(1.25893 0 0 1.58333 985.454 519.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 15.147c-9.754.139-18.562 6.457-18.753 14.271q-.093 11.461 0 22.922c.096 3.93 4.642 7.488 9.985 7.514 0 0 2.63-.241 3.465-1.738.963-1.725-.844-3.895-3.451-3.97-.751-.021-.747-.066-1.07-.182-.846-.304-1.412-.983-1.43-1.695q-.093-11.39.001-22.78c.107-4.382 4.977-8.345 10.777-8.619q.213-.01.427-.014c.758-.014.201.144 1.367-.123 3.184-.729 4.092-5.443-1.08-5.587z",
    style: {
      fill: "#969ea6",
      fillRule: "nonzero"
    },
    transform: "matrix(-.78333 0 0 1.04033 1475.256 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.612 4.001c6.863.146 13.027 6.755 13.072 14.786V56c-.222 5.858-4.35 4.57-5.943 3.003-.745-.733-1.152-1.357-1.215-3.003 0-12.43.07-24.859 0-37.289-.06-3.514-2.824-6.643-6.004-6.71q-23.986-.17-47.97 0c-3.146.066-5.952 3.087-5.973 6.776 0 0-2.364 6.512-5.944 2.991-4.73-4.653 2.665-17.572 11.826-17.767q24.076-.17 48.151 0",
    style: {
      fill: "#4d5868",
      fillRule: "nonzero"
    },
    transform: "matrix(1.09436 0 0 .98958 1002.579 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 3.956v8q-4.163.018-8.324.045c-3.516.066-6.653 3.087-6.676 6.776 0 0-2.642 6.512-6.643 2.991-5.287-4.653 2.979-17.572 13.217-17.767q4.213-.027 8.426-.045",
    style: {
      fill: "#323c58"
    },
    transform: "matrix(.97917 0 0 .98958 1148.417 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 8.002a4.01 4.01 0 0 1 4.015-4.006l2.375.005c7.67.146 14.559 6.755 14.61 14.786v3.275a3.94 3.94 0 0 1-1.153 2.785A3.94 3.94 0 0 1 317.062 26h-.001a4.06 4.06 0 0 1-4.062-4.062v-3.227c-.067-3.514-3.155-6.643-6.71-6.71l-2.306-.005A3.99 3.99 0 0 1 300 8.004z",
    style: {
      fill: "#363e58"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 8.002a4.01 4.01 0 0 1 4.015-4.006l2.375.005c7.67.146 14.559 6.755 14.61 14.786v3.275a3.94 3.94 0 0 1-1.153 2.785A3.94 3.94 0 0 1 317.062 26h-.001a4.06 4.06 0 0 1-4.062-4.062v-3.227c-.067-3.514-3.155-6.643-6.71-6.71l-2.306-.005A3.99 3.99 0 0 1 300 8.004zM313 47h8v15h-8z",
    style: {
      fill: "#323c58"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 47h-8v11c0 1.061.421 2.078 1.172 2.828a3.995 3.995 0 0 0 5.656 0A4 4 0 0 0 321 58z",
    style: {
      fill: "#526a88"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 546.104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 54.5c0-4.142-1.791-7.5-4-7.5s-4 3.358-4 7.5 1.791 7.5 4 7.5 4-3.358 4-7.5",
    style: {
      fill: "#657b95"
    },
    transform: "matrix(.97917 0 0 .52778 1034.833 562.861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.242 18h-.002c-4.042 0-7.918 1.222-10.776 3.397S232 26.521 232 29.597v22.647c0 2.627 2.798 4.756 6.25 4.756q0 0 0 0",
    style: {
      fill: "none",
      stroke: "#c8dee4",
      strokeWidth: "6.42px"
    },
    transform: "matrix(.78333 0 0 1.04033 1083.204 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.242 18h-.002c-4.042 0-7.918 1.222-10.776 3.397S232 26.521 232 29.597v22.647c0 2.627 2.798 4.756 6.25 4.756q0 0 0 0",
    style: {
      fill: "none",
      stroke: "#c8dee4",
      strokeWidth: "6.42px"
    },
    transform: "matrix(-.78333 0 0 1.04033 1470.36 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 15h-10c-.796 0-1.559.316-2.121.879a2.996 2.996 0 0 0 0 4.242A3 3 0 0 0 239 21h10z",
    style: {
      fill: "#4d5868"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 555.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 18c0-1.657-2.91-3-6.5-3h-.1c-3.534 0-6.4 1.323-6.4 2.954v.092c0 1.631 2.866 2.954 6.4 2.954h.1c3.59 0 6.5-1.343 6.5-3",
    style: {
      fill: "#657b95"
    },
    transform: "matrix(.45192 0 0 .98958 1159.263 555.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25 56.306C255.128 54.34 280 57 280 57h3v28h-6v-.001a30.59 30.59 0 0 0-14.291-25.886z",
    style: {
      fill: "#b8bdc6"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.367 41a.56.56 0 0 0-.25 1.059h.001a9.44 9.44 0 0 1 4.935 6.151l.272 1.091a.85.85 0 0 0 1.626.084L260 41z",
    style: {
      fill: "#b8bdc6"
    },
    transform: "matrix(1.14236 0 0 1.15451 992.403 548.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.367 41a.56.56 0 0 0-.25 1.059h.001a9.44 9.44 0 0 1 4.935 6.151l.272 1.091a.85.85 0 0 0 1.626.084L260 41z",
    style: {
      fill: "#b8bdc6"
    },
    transform: "matrix(-1.14236 0 0 1.15451 1625.597 548.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 89V75.058c0-2.667.637-5.295 1.858-7.665L294 38h9l2.748 10.307a8.42 8.42 0 0 1-2.183 8.128l-13.84 7.11A12.38 12.38 0 0 0 283 74.56V89a3 3 0 1 1-6 0M275 5h-16a14 14 0 0 0-14 14v17.39a6 6 0 0 0 4.454 5.798L275 49z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 38h-9l-2.401 9.005a8.43 8.43 0 0 0 3.651 9.301L279 70V57z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.97917 0 0 .98958 1035.813 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 5h-16a14 14 0 0 0-14 14v17.39a6 6 0 0 0 4.454 5.798L275 49z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(-.97917 0 0 .98958 1583.167 556)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.18 22.465a29.3 29.3 0 0 0-2.589-3.866C251.937 16.701 251 14.21 251 11.5 251 5.149 256.149 0 262.5 0h35c6.351 0 11.5 5.149 11.5 11.5 0 2.71-.937 5.2-2.505 7.166a29 29 0 0 0-2.58 3.853C298.621 31.749 280 65 280 65z",
    style: {
      fill: "#73c9eb"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.18 22.465a29.3 29.3 0 0 0-2.589-3.866C251.937 16.701 251 14.21 251 11.5 251 5.149 256.149 0 262.5 0h35c6.351 0 11.5 5.149 11.5 11.5 0 2.71-.937 5.2-2.505 7.166a29 29 0 0 0-2.58 3.853C298.621 31.749 280 65 280 65z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.675 31.816a4.002 4.002 0 0 0 6.03 1.153L286 18h-32z",
    style: {
      fill: "#4a92e8"
    },
    transform: "translate(2 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.675 31.816a4.002 4.002 0 0 0 6.03 1.153L286 18h-32z",
    style: {
      fill: "#4a92e8"
    },
    transform: "matrix(-1 0 0 1 558 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 30h-4l-8 24 4 14h12l4-14z",
    style: {
      fill: "#374cd2"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282 30h-4l-8 24 4 14h12l4-14z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291 25.333 267 42v5l24-16.667z",
    style: {
      fill: "#3777e5"
    },
    transform: "matrix(1 0 0 1.2 2 -4.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 25.333 267 42v5l24-16.667z",
    style: {
      fill: "#3777e5"
    },
    transform: "matrix(1 0 0 1.2 2 7.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 25.333 267 42v5l24-16.667z",
    style: {
      fill: "#3777e5"
    },
    transform: "matrix(1 0 0 1.2 2 19.6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288 24-8-5-8 5 2.633 7.241A5.71 5.71 0 0 0 279.999 35h.002a5.71 5.71 0 0 0 5.366-3.759z",
    style: {
      fill: "#3761e5"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288 24-8-5-8 5 2.633 7.241A5.71 5.71 0 0 0 279.999 35h.002a5.71 5.71 0 0 0 5.366-3.759z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140 22 24-3 24 3-7.675 13.816a4.002 4.002 0 0 1-6.03 1.153L164 28.545l-10.295 8.424a4.002 4.002 0 0 1-6.03-1.153z",
    style: {
      fill: "#374cd2"
    },
    transform: "translate(116)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.483 27.805a1.66 1.66 0 0 0-1.422-.805h-.002a1.731 1.731 0 0 0-1.485 2.623l.943 1.572c.3.499.839.805 1.422.805h.002a1.731 1.731 0 0 0 1.485-2.623z",
    style: {
      fill: "#3777e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.102 33.171a4 4 0 0 0 6.503.503L280 20v-2h-27z",
    style: {
      fill: "#73c9eb"
    },
    transform: "matrix(-1 0 0 1 560 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.102 33.171a4 4 0 0 0 6.503.503L280 20v-2h-27z",
    style: {
      fill: "#73c9eb"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296 8c0-1.857-.485-3.637-1.349-4.95-.863-1.313-2.034-2.05-3.255-2.05h-24.792c-1.221 0-2.392.737-3.255 2.05C262.485 4.363 262 6.143 262 8s.485 3.637 1.349 4.95c.863 1.313 2.034 2.05 3.255 2.05h24.792c1.221 0 2.392-.737 3.255-2.05C295.515 11.637 296 9.857 296 8",
    style: {
      fill: "#367ecd"
    },
    transform: "matrix(1.38235 0 0 .9189 923.323 560.029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 7.462c0-1.714-.597-3.358-1.66-4.569C293.278 1.681 291.836 1 290.333 1h-22.666c-1.503 0-2.945.681-4.007 1.893-1.063 1.211-1.66 2.855-1.66 4.569V15h34z",
    style: {
      fill: "#49a0e5"
    },
    transform: "matrix(1.03676 0 0 .9189 1019.743 560.029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.399 23a2 2 0 0 0-1.748 2.971l1.979 3.564a2.002 2.002 0 0 0 3.244.357l3.167-3.563A2.002 2.002 0 0 0 268.546 23z",
    style: {
      fill: "#b0e4ff"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.399 23a2 2 0 0 0-1.748 2.971l1.979 3.564a2.002 2.002 0 0 0 3.244.357l3.167-3.563A2.002 2.002 0 0 0 268.546 23z",
    style: {
      fill: "#4a92e8",
      fillOpacity: 0.5
    },
    transform: "matrix(-.97917 0 0 .98958 1583.167 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 29a3 3 0 1 0-6 0v6a3 3 0 1 0 6 0z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 29a3 3 0 1 0-6 0v6a3 3 0 1 0 6 0z",
    style: {
      fill: "#d4d4d4",
      fillOpacity: 0.5
    },
    transform: "matrix(.97917 0 0 .98958 1089.667 556)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 35.5,
    r: 3.5,
    style: {
      fill: "#fff"
    },
    transform: "matrix(.83929 0 0 .84821 1080.994 575.368)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 35.5,
    r: 3.5,
    style: {
      fill: "#d4d4d4",
      fillOpacity: 0.5
    },
    transform: "matrix(.83929 0 0 .84821 1118.202 575.368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 58a2.93 2.93 0 0 0-.919-2.121 3.2 3.2 0 0 0-2.217-.879h-16.728c-.831 0-1.629.316-2.217.879A2.93 2.93 0 0 0 305 58v6c0 5.523 4.681 10 10.455 10h2.09C323.319 74 328 69.523 328 64z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.9366 0 0 .98958 1048.797 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 30.5c0-2.485-1.343-4.5-3-4.5s-3 2.015-3 4.5v3c0 2.485 1.343 4.5 3 4.5s3-2.015 3-4.5z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.97917 0 0 .65972 1093.583 597.233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#3b557b"
    },
    transform: "matrix(1.25893 0 0 1.58333 968.81 519.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 36.333c0-1.841-1.343-3.333-3-3.333s-3 1.492-3 3.333v13.334c0 1.841 1.343 3.333 3 3.333s3-1.492 3-3.333z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.97917 0 0 .89063 1034.833 560.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 49a2 2 0 1 0-4 0v8a2 2 0 1 0 4 0z",
    style: {
      fill: "#3761e5"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 51c0-2.209-.895-4-2-4s-2 1.791-2 4v4c0 2.209.895 4 2 4s2-1.791 2-4z",
    style: {
      fill: "#4d90ff"
    },
    transform: "matrix(.97917 0 0 .4948 1034.833 579.255)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98947 0 0 .98958 1031.453 556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328 30.968a9.87 9.87 0 0 0-3.958-7.915L309.198 12h-57.396l-14.844 11.053A9.87 9.87 0 0 0 233 30.968v55.2c0 5.43 4.356 9.832 9.73 9.832h75.54c5.374 0 9.73-4.402 9.73-9.832z",
    style: {
      fill: "#ebebeb"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328 30.968a9.87 9.87 0 0 0-3.958-7.915L309.198 12h-57.396l-14.844 11.053A9.87 9.87 0 0 0 233 30.968v55.2c0 5.43 4.356 9.832 9.73 9.832h75.54c5.374 0 9.73-4.402 9.73-9.832z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98958 0 0 1 118.208 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 76a5 5 0 0 1-5-5c0-1.326.527-2.598 1.464-3.536A5 5 0 0 1 157 66h7V5h48v91h-57a5 5 0 0 1 0-10h14.002A5 5 0 0 0 174 81.002v-.004A5 5 0 0 0 169.002 76H157",
    style: {
      fill: "#d2d2d2"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 76a5 5 0 0 1-5-5c0-1.326.527-2.598 1.464-3.536A5 5 0 0 1 157 66h7V5h48v91h-57a5 5 0 0 1 0-10h14.002A5 5 0 0 0 174 81.002v-.004A5 5 0 0 0 169.002 76H157"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 20h8v39h-8z",
    style: {
      fill: "#b7b7b7"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M126 90a4 4 0 0 1-2.828-1.172A4 4 0 0 1 122 86V74a4 4 0 0 1 4-4c1.061 0 2.078.421 2.828 1.172A4 4 0 0 1 130 74v4.002A4 4 0 0 0 133.998 82H134c1.061 0 2.078.421 2.828 1.172a3.995 3.995 0 0 1 0 5.656A4 4 0 0 1 134 90z",
    style: {
      fill: "#b3b3b3"
    },
    transform: "matrix(-.98958 0 0 1 442.792 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 90a4 4 0 0 1-2.828-1.172A4 4 0 0 1 122 86V74a4 4 0 0 1 4-4c1.061 0 2.078.421 2.828 1.172A4 4 0 0 1 130 74v4.002A4 4 0 0 0 133.998 82H134c1.061 0 2.078.421 2.828 1.172a3.995 3.995 0 0 1 0 5.656A4 4 0 0 1 134 90z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.98958 0 0 1 118.208 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 58v28h-8v-1.002a7 7 0 0 0-6.999-6.997L205 78h-2c-5.523 0-10-4.477-10-10v-6c0-.796.316-1.559.879-2.121A3 3 0 0 1 196 59h16v-1z",
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(.98958 0 0 1 118.208 0)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 80,
    r: 3,
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(1.63194 0 0 1.6493 1042.667 499.264)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 80,
    r: 3,
    style: {
      fill: "#fff"
    },
    transform: "matrix(1.63194 0 0 1.6493 1040.708 497.285)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 80,
    r: 3,
    style: {
      fill: "#e3e3e3"
    },
    transform: "matrix(.65278 0 0 .65972 1208.146 576.451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.515 15.154c3.624.303 5.429 5.535-.273 5.7-2.165.062-2.953.238-4.139.586-4.246 1.247-7.266 4.532-7.352 8.049-.061 7.618-.44 15.244.002 22.855.089 1.186 2.52 1.802 2.497 1.802 5.743.16 4.597 7.492-2.736 5.419-3.997-1.13-7.18-3.924-7.263-7.223q-.092-11.463 0-22.924c.184-7.51 8.762-14.223 18.977-14.272q.144.002.287.008",
    style: {
      fill: "#8b949d",
      fillRule: "nonzero"
    },
    transform: "matrix(.78333 0 0 1.04033 1088.1 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(1.25893 0 0 1.58333 972.727 519.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(1.25893 0 0 1.58333 985.454 519.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 15.147c-9.754.139-18.562 6.457-18.753 14.271q-.093 11.461 0 22.922c.096 3.93 4.642 7.488 9.985 7.514 0 0 2.63-.241 3.465-1.738.963-1.725-.844-3.895-3.451-3.97-.751-.021-.747-.066-1.07-.182-.846-.304-1.412-.983-1.43-1.695q-.093-11.39.001-22.78c.107-4.382 4.977-8.345 10.777-8.619q.213-.01.427-.014c.758-.014.201.144 1.367-.123 3.184-.729 4.092-5.443-1.08-5.587z",
    style: {
      fill: "#8b949d",
      fillRule: "nonzero"
    },
    transform: "matrix(-.78333 0 0 1.04033 1475.256 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.612 4.001c6.863.146 13.027 6.755 13.072 14.786V56c-.222 5.858-4.35 4.57-5.943 3.003-.745-.733-1.152-1.357-1.215-3.003 0-12.43.07-24.859 0-37.289-.06-3.514-2.824-6.643-6.004-6.71q-23.986-.17-47.97 0c-3.146.066-5.952 3.087-5.973 6.776 0 0-2.364 6.512-5.944 2.991-4.73-4.653 2.665-17.572 11.826-17.767q24.076-.17 48.151 0",
    style: {
      fill: "#4d5868",
      fillRule: "nonzero"
    },
    transform: "matrix(1.09436 0 0 .98958 1002.579 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 3.956v8q-4.163.018-8.324.045c-3.516.066-6.653 3.087-6.676 6.776 0 0-2.642 6.512-6.643 2.991-5.287-4.653 2.979-17.572 13.217-17.767q4.213-.027 8.426-.045",
    style: {
      fill: "#323c58"
    },
    transform: "matrix(.97917 0 0 .98958 1148.417 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 8.002a4.01 4.01 0 0 1 4.015-4.006l2.375.005c7.67.146 14.559 6.755 14.61 14.786v3.275a3.94 3.94 0 0 1-1.153 2.785A3.94 3.94 0 0 1 317.062 26h-.001a4.06 4.06 0 0 1-4.062-4.062v-3.227c-.067-3.514-3.155-6.643-6.71-6.71l-2.306-.005A3.99 3.99 0 0 1 300 8.004z",
    style: {
      fill: "#363e58"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 8.002a4.01 4.01 0 0 1 4.015-4.006l2.375.005c7.67.146 14.559 6.755 14.61 14.786v3.275a3.94 3.94 0 0 1-1.153 2.785A3.94 3.94 0 0 1 317.062 26h-.001a4.06 4.06 0 0 1-4.062-4.062v-3.227c-.067-3.514-3.155-6.643-6.71-6.71l-2.306-.005A3.99 3.99 0 0 1 300 8.004z",
    style: {
      fill: "#323c58"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 47h8v15h-8z",
    style: {
      fill: "#323c58"
    },
    transform: "matrix(.97917 0 0 1.28646 1034.833 537.594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 47h-8v9.545c0 1.447.421 2.834 1.172 3.857S315.939 62 317 62s2.078-.575 2.828-1.598c.751-1.023 1.172-2.41 1.172-3.857z",
    style: {
      fill: "#526a88"
    },
    transform: "matrix(.97917 0 0 .7257 1034.833 558.507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 54.5c0-4.142-1.791-7.5-4-7.5s-4 3.358-4 7.5 1.791 7.5 4 7.5 4-3.358 4-7.5",
    style: {
      fill: "#657b95"
    },
    transform: "matrix(.97917 0 0 .52778 1034.833 562.861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.242 18h-.002c-4.042 0-7.918 1.222-10.776 3.397S232 26.521 232 29.597v22.647c0 2.627 2.798 4.756 6.25 4.756q0 0 0 0",
    style: {
      fill: "none",
      stroke: "#c8dee4",
      strokeWidth: "6.42px"
    },
    transform: "matrix(.78333 0 0 1.04033 1083.204 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.242 18h-.002c-4.042 0-7.918 1.222-10.776 3.397S232 26.521 232 29.597v22.647c0 2.627 2.798 4.756 6.25 4.756q0 0 0 0",
    style: {
      fill: "none",
      stroke: "#c8dee4",
      strokeWidth: "6.42px"
    },
    transform: "matrix(-.78333 0 0 1.04033 1470.36 557.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 15h-10c-.796 0-1.559.316-2.121.879a2.996 2.996 0 0 0 0 4.242A3 3 0 0 0 239 21h10z",
    style: {
      fill: "#4d5868"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 555.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 18c0-1.657-2.91-3-6.5-3h-.1c-3.534 0-6.4 1.323-6.4 2.954v.092c0 1.631 2.866 2.954 6.4 2.954h.1c3.59 0 6.5-1.343 6.5-3",
    style: {
      fill: "#657b95"
    },
    transform: "matrix(.45192 0 0 .98958 1159.263 555.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25 56.306C255.128 54.34 280 57 280 57h3v28h-6v-.001a30.59 30.59 0 0 0-14.291-25.886z",
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.367 41a.56.56 0 0 0-.25 1.059h.001a9.44 9.44 0 0 1 4.935 6.151l.272 1.091a.85.85 0 0 0 1.626.084L260 41z",
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(1.14236 0 0 1.15451 992.403 548.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.367 41a.56.56 0 0 0-.25 1.059h.001a9.44 9.44 0 0 1 4.935 6.151l.272 1.091a.85.85 0 0 0 1.626.084L260 41z",
    style: {
      fill: "#8b949d"
    },
    transform: "matrix(-1.14236 0 0 1.15451 1625.597 548.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 89V75.058c0-2.667.637-5.295 1.858-7.665L294 38h9l2.748 10.307a8.42 8.42 0 0 1-2.183 8.128l-13.84 7.11A12.38 12.38 0 0 0 283 74.56V89a3 3 0 1 1-6 0M275 5h-16a14 14 0 0 0-14 14v17.39a6 6 0 0 0 4.454 5.798L275 49z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 38h-9l-2.401 9.005a8.43 8.43 0 0 0 3.651 9.301L279 70V57z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.97917 0 0 .98958 1035.813 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 5h-16a14 14 0 0 0-14 14v17.39a6 6 0 0 0 4.454 5.798L275 49z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(-.97917 0 0 .98958 1583.167 556)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.18 22.465a29.3 29.3 0 0 0-2.589-3.866C251.937 16.701 251 14.21 251 11.5 251 5.149 256.149 0 262.5 0h35c6.351 0 11.5 5.149 11.5 11.5 0 2.71-.937 5.2-2.505 7.166a29 29 0 0 0-2.58 3.853C298.621 31.749 280 65 280 65z",
    style: {
      fill: "#99d3ef"
    }
  }), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.18 22.465a29.3 29.3 0 0 0-2.589-3.866C251.937 16.701 251 14.21 251 11.5 251 5.149 256.149 0 262.5 0h35c6.351 0 11.5 5.149 11.5 11.5 0 2.71-.937 5.2-2.505 7.166a29 29 0 0 0-2.58 3.853C298.621 31.749 280 65 280 65z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.675 31.816a4.002 4.002 0 0 0 6.03 1.153L286 18h-32z",
    style: {
      fill: "#4a92e8"
    },
    transform: "translate(2 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.675 31.816a4.002 4.002 0 0 0 6.03 1.153L286 18h-32z",
    style: {
      fill: "#4a92e8"
    },
    transform: "matrix(-1 0 0 1 558 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 30h-4l-8 24 4 14h12l4-14z",
    style: {
      fill: "#374cd2"
    }
  }), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282 30h-4l-8 24 4 14h12l4-14z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291 25.333 267 42v5l24-16.667z",
    style: {
      fill: "#3777e5"
    },
    transform: "matrix(1 0 0 1.2 2 -4.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 25.333 267 42v5l24-16.667z",
    style: {
      fill: "#3777e5"
    },
    transform: "matrix(1 0 0 1.2 2 7.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 25.333 267 42v5l24-16.667z",
    style: {
      fill: "#3777e5"
    },
    transform: "matrix(1 0 0 1.2 2 19.6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288 24-8-5-8 5 2.633 7.241A5.71 5.71 0 0 0 279.999 35h.002a5.71 5.71 0 0 0 5.366-3.759z",
    style: {
      fill: "#3761e5"
    }
  }), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-3747004563__l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288 24-8-5-8 5 2.633 7.241A5.71 5.71 0 0 0 279.999 35h.002a5.71 5.71 0 0 0 5.366-3.759z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-3747004563__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140 22 24-3 24 3-7.675 13.816a4.002 4.002 0 0 1-6.03 1.153L164 28.545l-10.295 8.424a4.002 4.002 0 0 1-6.03-1.153z",
    style: {
      fill: "#374cd2"
    },
    transform: "translate(116)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.483 27.805a1.66 1.66 0 0 0-1.422-.805h-.002a1.731 1.731 0 0 0-1.485 2.623l.943 1.572c.3.499.839.805 1.422.805h.002a1.731 1.731 0 0 0 1.485-2.623z",
    style: {
      fill: "#5aa0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.102 33.171a4 4 0 0 0 6.503.503L280 20v-2h-27z",
    style: {
      fill: "#99d3ef"
    },
    transform: "matrix(-1 0 0 1 560 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.102 33.171a4 4 0 0 0 6.503.503L280 20l3-2h-30z",
    style: {
      fill: "#99d3ef"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296 8c0-1.857-.485-3.637-1.349-4.95-.863-1.313-2.034-2.05-3.255-2.05h-24.792c-1.221 0-2.392.737-3.255 2.05C262.485 4.363 262 6.143 262 8s.485 3.637 1.349 4.95c.863 1.313 2.034 2.05 3.255 2.05h24.792c1.221 0 2.392-.737 3.255-2.05C295.515 11.637 296 9.857 296 8",
    style: {
      fill: "#2b74cd"
    },
    transform: "matrix(1.38235 0 0 .9189 923.323 560.029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 7.462c0-1.714-.597-3.358-1.66-4.569C293.278 1.681 291.836 1 290.333 1h-22.666c-1.503 0-2.945.681-4.007 1.893-1.063 1.211-1.66 2.855-1.66 4.569V15h34z",
    style: {
      fill: "#4396e4"
    },
    transform: "matrix(1.03676 0 0 .9189 1019.743 560.029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.399 23a2 2 0 0 0-1.748 2.971l1.979 3.564a2.002 2.002 0 0 0 3.244.357l3.167-3.563A2.002 2.002 0 0 0 268.546 23z",
    style: {
      fill: "#b0e4ff"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.399 23a2 2 0 0 0-1.748 2.971l1.979 3.564a2.002 2.002 0 0 0 3.244.357l3.167-3.563A2.002 2.002 0 0 0 268.546 23z",
    style: {
      fill: "#4a92e8",
      fillOpacity: 0.5
    },
    transform: "matrix(-.97917 0 0 .98958 1583.167 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 29a3 3 0 1 0-6 0v6a3 3 0 1 0 6 0z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 29a3 3 0 1 0-6 0v6a3 3 0 1 0 6 0z",
    style: {
      fill: "#d4d4d4",
      fillOpacity: 0.5
    },
    transform: "matrix(.97917 0 0 .98958 1089.667 556)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 35.5,
    r: 3.5,
    style: {
      fill: "#fff"
    },
    transform: "matrix(.83929 0 0 .84821 1080.994 575.368)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 35.5,
    r: 3.5,
    style: {
      fill: "#d4d4d4",
      fillOpacity: 0.5
    },
    transform: "matrix(.83929 0 0 .84821 1118.202 575.368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 58a2.93 2.93 0 0 0-.919-2.121 3.2 3.2 0 0 0-2.217-.879h-16.728c-.831 0-1.629.316-2.217.879A2.93 2.93 0 0 0 305 58v6c0 5.523 4.681 10 10.455 10h2.09C323.319 74 328 69.523 328 64z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.9366 0 0 .98958 1048.797 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 30.5c0-2.485-1.343-4.5-3-4.5s-3 2.015-3 4.5v3c0 2.485 1.343 4.5 3 4.5s3-2.015 3-4.5z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.97917 0 0 .65972 1093.583 597.233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#3b557b"
    },
    transform: "matrix(1.25893 0 0 1.58333 968.81 519.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 36.333c0-1.841-1.343-3.333-3-3.333s-3 1.492-3 3.333v13.334c0 1.841 1.343 3.333 3 3.333s3-1.492 3-3.333z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.97917 0 0 .89063 1034.833 560.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 49a2 2 0 1 0-4 0v8a2 2 0 1 0 4 0z",
    style: {
      fill: "#3761e5"
    },
    transform: "matrix(.97917 0 0 .98958 1034.833 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 51c0-2.209-.895-4-2-4s-2 1.791-2 4v4c0 2.209.895 4 2 4s2-1.791 2-4z",
    style: {
      fill: "#4d90ff"
    },
    transform: "matrix(.97917 0 0 .4948 1034.833 579.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.125 35.816c0-.732-.508-1.398-1.304-1.709-.796-.31-1.735-.209-2.41.259l-1.671 1.161c-.516.358-.815.889-.815 1.449v.087c0 .732.508 1.399 1.304 1.709s1.735.21 2.41-.259l1.671-1.16c.516-.359.815-.89.815-1.45z",
    style: {
      fill: "#5aa0f0"
    },
    transform: "matrix(.97917 0 0 1.1875 1040.586 553.058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.125 35.803c0-.732-.507-1.397-1.301-1.708-.795-.311-1.733-.212-2.409.255l-4.083 2.821c-.519.358-.819.891-.819 1.452v.098c0 .731.507 1.397 1.301 1.708s1.733.211 2.409-.255l4.083-2.821c.519-.359.819-.891.819-1.453z",
    style: {
      fill: "#5aa0f0"
    },
    transform: "matrix(.97917 0 0 1.1875 1043.621 562.407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 4.333C168 3.045 167.105 2 166 2h-5c-1.105 0-2 1.045-2 2.333V9h9z",
    style: {
      fill: "#f2f2f2"
    },
    transform: "matrix(.97917 0 0 .84821 1148.417 557.272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 10.499c0-.828-.774-1.499-1.729-1.499h-5.542c-.955 0-1.729.671-1.729 1.499v.002c0 .828.774 1.499 1.729 1.499h5.542c.955 0 1.729-.671 1.729-1.499z",
    style: {
      fill: "#2b74cd"
    },
    transform: "matrix(1.41435 0 0 1.6493 1077.264 550.063)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 7.5a1.503 1.503 0 0 0-1.5-1.5h-2a1.503 1.503 0 0 0-1.5 1.5 1.503 1.503 0 0 0 1.5 1.5h2a1.503 1.503 0 0 0 1.5-1.5",
    style: {
      fill: "#a1aeb5"
    },
    transform: "matrix(.97917 0 0 .98958 1148.417 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 60.499c0-.663-.328-1.299-.911-1.767-.583-.469-1.374-.732-2.199-.732h-.78c-1.718 0-3.11 1.119-3.11 2.499v.002c0 .663.328 1.299.911 1.767.583.469 1.374.732 2.199.732h.78c.825 0 1.616-.263 2.199-.732s.911-1.104.911-1.767z",
    style: {
      fill: "#3b557b"
    },
    transform: "matrix(1.25893 0 0 1.58333 981.54 519.583)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuit);
export default ForwardRef;